const H3Base = ({text, className}) => {
    let finalClass = "mb-6 text-secondary text-xl font-semibold";

    if (typeof className === "string") {
        finalClass += ` ${className}`;
    }
    return <h3 className={finalClass}>{text}</h3>
}

export default H3Base;